import { THIRD_PARTY_MODEL_TYPES } from "./constants";
import type { WenxinMeta, _IImportWenxinMeta } from "./wenxin/meta";
import type { FormattedMonkeyMeta, _IImportMonkeyMeta } from "./monkey/meta";
import type { DraftMeta, _IImportDraftMeta } from "./draft/meta";

export type ThirdPartyMeta = WenxinMeta | FormattedMonkeyMeta | DraftMeta;
export type _IImportThirdPartyMeta = _IImportWenxinMeta | _IImportMonkeyMeta | _IImportDraftMeta;

export function isThirdPartyMeta(meta: any): meta is ThirdPartyMeta {
  return THIRD_PARTY_MODEL_TYPES.includes(meta.type);
}
